import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import { green } from '@material-ui/core/colors';
import makeStyles from '@material-ui/core/styles/makeStyles';
import LocalAtmTwoToneIcon from '@material-ui/icons/LocalAtmTwoTone';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import React, { useCallback, useState } from 'react';
import { Experience } from '../../API';

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'right',
    '& span': {
      display: 'inline-block',
      lineHeight: 2,
      verticalAlign: 'middle',
    },
  },
  button: {
    padding: 0,
  },
  dollarIcon: {
    marginRight: theme.spacing(1),
    color: green[600],
    verticalAlign: 'middle',
  },
  infoIcon: {
    marginLeft: theme.spacing(1),
    color: theme.palette.info.light,
    verticalAlign: 'middle',
  },
}));

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

function format(amount: number) {
  return formatter.format(amount);
}

const RANGE_PER_EXPERIENCE = {
  [Experience.FROM_0_TO_2]: [3000, 4000],
  [Experience.FROM_2_TO_3]: [3500, 5000],
  [Experience.FROM_3_TO_5]: [4000, 7000],
  [Experience.FROM_5_TO_10]: [5000, 8000],
  [Experience.FROM_10_AND_MORE]: [6000, 13000],
};

export default function SalaryRange({ experience }: { experience?: Experience }) {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState(false);
  const handleOpen = useCallback(() => setModalOpen(true), []);
  const handleClose = useCallback(() => setModalOpen(false), []);
  if (!experience) return null;
  const range = RANGE_PER_EXPERIENCE[experience];
  return (
    <Box className={classes.root}>
      <Button onClick={handleOpen} className={classes.button}>
        <LocalAtmTwoToneIcon className={classes.dollarIcon} />
        <span>
          {format(range[0])}
          &nbsp;
          -
          &nbsp;
          {format(range[1])}
        </span>
        <InfoOutlinedIcon className={classes.infoIcon} />
      </Button>
      <Dialog
        open={modalOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Salary Ranges</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            This is the salary range we are finding for the vast majority of engineers
            with your expertise when matched with companies in our network. Note that,
            in the end, there is still an open negotiation with the specific company,
            considering your evaluated skills, that can improve this further.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Roger that
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
